import React, { Fragment } from 'react'
import BookFVButton from './BookFVButton'
import { ButtonLink, HeaderAvatar, typography, spacer } from 'stylist'
import styled from 'react-emotion'

const PullDownHeader = styled.div`
  margin: ${spacer(2)} ${spacer(3)};
  ${typography('title1')};
`

const HeaderAvatarContainer = styled.div`
  display: flex;
  margin-left: ${spacer(4)};
  align-items: center;
`

const AvatarMenu = ({ first_name, last_name, email, is_admin }) => (
  <HeaderAvatarContainer>
    <HeaderAvatar
      align="right"
      hideUserName={true}
      firstName={first_name}
      lastName={last_name}
      email={email}
    >
      <HeaderAvatar.MenuSection>
        <PullDownHeader>{email}</PullDownHeader>
        {is_admin && (
          <HeaderAvatar.MenuItem to="/admin">Admin</HeaderAvatar.MenuItem>
        )}
        <HeaderAvatar.MenuItem to="/logout">Sign Out</HeaderAvatar.MenuItem>
      </HeaderAvatar.MenuSection>
    </HeaderAvatar>
  </HeaderAvatarContainer>
)

AvatarMenu.defaultProps = {
  first_name: '',
  last_name: '',
  email: '',
  is_admin: false
}

const DesktopMenu = ({ isAuthenticated, currentUser }) => (
  <Fragment>
    {isAuthenticated ? (
      <Fragment>
        <BookFVButton />
        <AvatarMenu {...currentUser} />
      </Fragment>
    ) : (
      <Fragment>
        <ButtonLink to="/login" kind="ghost">
          Sign In
        </ButtonLink>
        <BookFVButton />
      </Fragment>
    )}
  </Fragment>
)

export default DesktopMenu



// WEBPACK FOOTER //
// ./src/routes/components/DesktopMenu.js